export interface EventTheme {
  key: string;
  startDate: string;
  endDate: string;
  gifPath: string;
}

export interface Theme {
  gifPath: string;
}

export interface ThemeConfig {
  eventThemes: EventTheme[];
  defaultTheme: Theme;
}

export const createThemeManager = (config: ThemeConfig) => {
  const { eventThemes, defaultTheme } = config;

  const getCurrentTheme = (): Theme => {
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];

    for (const event of eventThemes) {
      if (todayStr >= event.startDate && todayStr <= event.endDate) {
        return { gifPath: event.gifPath };
      }
    }

    return defaultTheme;
  };

  const getThemeByKey = (key: string): Theme | undefined => {
    const event = eventThemes.find(e => e.key === key);
    return event ? { gifPath: event.gifPath } : undefined;
  };

  return {
    getCurrentTheme,
    getThemeByKey,
    eventThemes,
    defaultTheme
  };
};
